import React, { useState, useEffect } from 'react';
import MainMenu from '../../components/menu/Menu';
import './style/style.css';
import DeviceOne from '../../components/deviceOne/DeviceOne';
import { Layout } from 'antd';
import { useBlocker, useParams } from 'react-router-dom';
import { useIsFormChanged } from '../../store/devices/getDeviceChange';
import NotSavedChanges from '../../components/modals/notSavedChanges/NotSavedChanges';
import { useDevicesLoader } from '../../hooks/useDevicesLoader';
import { useSelectedDevice } from '../../store/devices/SelectedDevice';
import { DeviceByGroupStore } from '../../store/devices/DeviceByGroupStore';

const { Header, Content } = Layout;

interface DeviceProps {
    selectedUID?: string;
}
const Device: React.FC<DeviceProps> = ({ selectedUID }) => {
    const [currentMenuItem, setCurrentMenuItem] = useState('device');
    const { isFormChanged, setIsNotSavedModalVisible } = useIsFormChanged();
    const handleMenuClick = (key: string) => {
        setCurrentMenuItem(key);
    };
    const { id } = useParams();
    const { devices } = useDevicesLoader();
    const { setSelectedDevice } = useSelectedDevice();
    useEffect(() => {
        if (id && devices.length) {
            const device = devices.find((d) => d.DID === id);
            console.log(device);

            if (device) setSelectedDevice(device);
        }
    }, [id, devices, setSelectedDevice]);

    useBlocker(() => {
        if (isFormChanged) {
            setIsNotSavedModalVisible(true);
            return true;
        }
        return false;
    });

    return (
        <Layout>
            <Header
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: 0,
                    paddingRight: 0,
                    background: '#fff',
                }}
            >
                <div className="menu">
                    <MainMenu onClick={handleMenuClick} currentMenuItem={currentMenuItem} />
                </div>
            </Header>
            <Layout>
                <Content style={{ background: '#ffffff' }}>
                    <div className="deviceOne">
                        <DeviceOne />
                    </div>
                </Content>
            </Layout>
        </Layout>
    );
};

export default Device;
